<template>
        <Row>
            <Col :span="dateSpan">
                <DatePicker 
                    :type="attrs.type || 'daterange'"
                    :options="attrs.type == 'daterange' ? options : dateOptions" 
                    :value="bindValue"
                    placement="bottom-end" 
                    :placeholder="attrs.placeholder || '请选择日期'" 
                    @on-change="changeHandle"
                    style="width: 100%;"
                    :transfer="true"
                    :disabled="!watchDisplay">
                </DatePicker>
            </Col>
            <Col :span="timeSpan" v-if="attrs.isTimePicker">
                <TimePicker v-model="bindtimeValue" @on-open-change="timeHandle" type="time" placeholder="请选择时分秒"></TimePicker>
            </Col>
        </Row>
</template>
<script>
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    export default {
        name: 'LyDatepicker',
        mixins: [CompDisplayMixin],
        props: {
            page: {
                type: Object,
                default: _ => new Object()
            }, // 所在页面的书记，目前用到是form直接传递过来，获得表单其他的状态，来改变自身状态
            value: {
                type: [String, Number],
                default: ''
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        watch: {
            value: {
                handler () {
                    this.splitValue()
                },
                immediate: true
            }
        },
        data () {
            return {
                bindValue: [],
                dateValue: [], // 存放日期选择的数据
                dateSpan: 24,
                timeSpan: 0,
                bindtimeValue: '',
                options: {
                    shortcuts: [
                        {
                            text: '一周内',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '一个月内',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '三个月内',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                },
                /**
                 * 选择日期的配置项
                 */
                dateOptions: {
                }
            }
        }, 
        created () {
            this.setDefault() // 设置默认值
        },
        mounted () {
            // 设置显示时分秒选择器时 datapicker的宽度
            if (this.attrs.isTimePicker) {
                this.dateSpan = 15
                this.timeSpan = 9
            }
            // 设置一个无关的值，触发display的处理
            // 新增时，checkbox没值，不能根据判断
            this.$set(this.page, 'w', 'w')
            // 设置今日之前不可选
            if (this.attrs.isDisToday) {
                this.dateOptions['disabledDate'] = date => date && date.valueOf() < Date.now()
            }
        },
        methods: {     
            splitValue () {
                if (this.value.length > 0) {
                    if (this.attrs.type == 'date') { // 单日
                        if (this.attrs.isTimePicker) { // 时分秒开启时
                            let arr = this.value.split(' ') // 拆分
                            this.bindValue = arr[0] // 绑定日期
                            this.dateValue = this.bindValue
                            this.bindtimeValue = arr[1] // 绑定时分秒
                        } else {
                            this.bindValue = this.value
                        }
                    } else if (this.attrs.type == 'month' || this.attrs.type == 'year') {  
                        this.bindValue = this.value
                    } else {
                        let arr = this.value.split('~')                        
                        if (arr.length < 2 && this.value.indexOf('-')) {
                            arr = this.value.split('-')
                        } 
                        if (arr.length === 2 ){
                            if(this.attrs.isTimePicker) { // 开启时分秒时
                                let timeArr = []
                                let time1Arr = arr[0].split(' ')
                                let time2Arr = arr[1].split(' ')
                                timeArr.push(time1Arr[0])
                                timeArr.push(time2Arr[0])
                                this.bindValue = timeArr
                                this.bindtimeValue = time1Arr[0]
                            } else {
                                this.bindValue = arr
                            }
                        }
                    }
                } else {
                    this.bindValue = ''
                }
            },
            changeHandle (val) {
                this.dateValue = val
                if (typeof val == 'string') {
                    if (this.value !== val) {
                        this.$emit('input', val)
                    }
                } else {
                    // 未选后是两个空字符串，要判断
                    if (val.length > 0 && val[0].length > 0) {
                        val = val.join('-')
                    } else {
                        val = ''
                    }
                    if (this.value !== val) {
                        this.$emit('input', val)
                    }
                }
            },
            timeHandle (val) {
                if (this.dateValue && this.bindtimeValue && typeof this.dateValue == 'string') { // 单日模式并且已选择日期
                    let newVal = this.dateValue + " " + this.bindtimeValue
                    this.$emit('input', newVal)
                } else if (this.dateValue && this.bindtimeValue && this.dateValue.length == 2) { //时间段 并且已选择时间段
                    this.dateValue.forEach((item, index) => {
                        this.dateValue[index] = item + " " +this.bindtimeValue
                    })
                    let newVal = this.dateValue.join('-')
                    this.$emit('input', newVal)
                }
            },
            // 设置默认值， 总览g2-chart数据查询中需要设置默认日期 by wxf in 2021-4-16
            setDefault() {
                let end = new Date()
                let start = new Date()
                let rs = ''
                switch(this.attrs.default) {                    
                    case '1': // 近一周
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        rs = this.transformTimestamp(start) + '~' + this.transformTimestamp(end)
                        break
                    case '2': // 近一月
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        rs = this.transformTimestamp(start) + '~' + this.transformTimestamp(end)
                        break
                    default:
                        rs = ''
                }
                if(rs.length > 0) {
                    this.bindValue = rs.split("~")
                    let newBindValue = this.bindValue.join("-")
                    this.$emit('input', newBindValue)
                }                
            },
            /**
             * @function 时间戳转化为年月日
             * @param {string} date
             * @returns {number} 时间
             * */
            transformTimestamp (timestamp) {
                const date = new Date(timestamp)
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = date.getDate()
                const dateString = Y + M + D
                return dateString
            }
        }
    }
</script>
<style>
.ivu-select-dropdown {
    z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/datepicker/src/index.vue